import React from "react";
import { Field } from "react-final-form";
import SelectAdapter from "@soqs/common/dist/Components/Adapters/SelectAdapter";

const SelectComponent = (props) => {
  let { required, optionsloading, label } = props;

  if (optionsloading === undefined) {
    optionsloading = false;
  }
  if (required === undefined) {
    required = false;
  }

  const isRequired = (x) => {
    return (x || !required) &&
      (true || (!required && (x === undefined || x?.length === 0)))
      ? undefined
      : "A " + label + " must be selected";
  };

  return (
    <Field
      required={required}
      label={label}
      fullWidth
      validate={isRequired}
      component={SelectAdapter}
      //options={taxoptions}
      loading={optionsloading}
      //disabled={disabled}
      subscription={{ touched: true, value: true, error: true }}
      {...props}
    />
  );
};

export default SelectComponent;
